import CustomInput from "@/components/CustomInput/CustomInput";
import ChipSearchInput from "@/components/CustomInput/ChipInputField";
import type { CompanyProfileData } from "@/types/companyProfile";
import type { TenantProfilePayload } from "@/types/tenantService";
import React, { useEffect } from "react";

interface Props {
  formData: TenantProfilePayload;
  setFormData: React.Dispatch<React.SetStateAction<TenantProfilePayload>>;
  data?: CompanyProfileData;
  errors?: Record<string, string>;
  setFormErrors?: React.Dispatch<React.SetStateAction<Record<string, string>>>;
}

const CompanyBasics: React.FC<Props> = ({
  formData,
  setFormData,
  data,
  errors = {},
  setFormErrors,
}) => {
  useEffect(() => {
    if (data?.about) {
      setFormData((prev) => ({ ...prev, whoweare: data.about }));
    }

    if (data?.valueProposition) {
      setFormData((prev) => ({
        ...prev,
        valueProposition: data.valueProposition ?? [],
      }));
    }

    if (data?.productsServices) {
      setFormData((prev) => ({
        ...prev,
        productsServices: data.productsServices ?? [],
      }));
    }
  }, [data, setFormData]);

  const handleChipChange = (
    key: keyof TenantProfilePayload,
    newValues: string[],
  ) => {
    setFormData((prev) => ({ ...prev, [key]: newValues }));

    // Clear or set error when user interacts
    setFormErrors?.((prev) => {
      const updated = { ...prev };
      if (newValues.length > 0) delete updated[key];
      return updated;
    });
  };

  return (
    <div className="text-white space-y-4">
      <CustomInput
        label="About"
        name="whoweare"
        placeholder="About"
        value={formData.whoweare}
        onChange={(e) => {
          const { name, value } = e.target;
          setFormData((prev) => ({ ...prev, [name]: value }));
          setFormErrors?.((prev) => ({ ...prev, [name]: "" }));
        }}
        error={errors.whoweare} // 👈 shows parent’s validation message immediately
      />

      <ChipSearchInput
        label="Product"
        values={formData.productsServices}
        onChange={(newValues) =>
          handleChipChange("productsServices", newValues)
        }
        error={errors.productsServices}
      />

      <ChipSearchInput
        label="Value Proposition"
        values={formData.valueProposition}
        onChange={(newValues) =>
          handleChipChange("valueProposition", newValues)
        }
        error={errors.valueProposition}
      />
    </div>
  );
};

export default CompanyBasics;
